<div class="card b-0 mt-3 mt-lg-0">
  <div class="card-body p-3">
    <div class="d-flex flex-column flex-lg-row justify-content-between">
      <fgbcl-date-range-picker [minDate]="minDate" [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate">
      </fgbcl-date-range-picker>
      <button (click)="getTransactions()" type="button" class="transaction-search-button">
        {{ 'fgbcl.card.linking.transaction.search.label' | translate }}
      </button>
    </div>
  </div>
</div>

<div class="container card-linked-transaction-list-header">
  <div class="row p-2">
    <div class="col-9">
      <div class="row">
        <div class="col-4 d-none d-lg-block cardlink-transaction-label">
          {{ 'fgbcl.card.linking.transaction.date.label' | translate }}
        </div>
        <div class="col-5 d-none d-lg-block cardlink-transaction-label">
          {{ 'fgbcl.card.linking.transaction.description.label' | translate }}
        </div>
        <div class="col-9 d-lg-none cardlink-transaction-label">
          {{ 'fgbcl.card.linking.transaction.detail.label' | translate }}
        </div>
      </div>
    </div>
    <div class="col-3 text-end">{{ 'fgbcl.card.linking.transaction.currency.label' | translate }}</div>
  </div>
</div>

<ng-container *ngIf="transactions$ | async as transactions">
  <div id="cardTransactionList" #cardTransactionList>
    <div *ngIf="hasTransactions" class="container card-linked-transaction-list-body">
      <div *ngFor="let day of transactions | keyvalue: keepOrder">
        <div class="row transaction-detail-row" *ngFor="let transaction of day.value">
          <div class="col-9">
            <div class="row">
              <div class="col-9 col-lg-4 cardlink-transaction-date">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: dateFormat | uppercase }}
              </div>
              <div class="col-9 col-lg-5 fw-bold pe-0">{{ transaction.TransactionDescription }}</div>
            </div>
          </div>
          <div class="col-3 text-end">
            <div
              *ngIf="transaction.AccountDescriptionId != 0"
              class="fw-bold transaction-text text-capitalize"
              [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
            >
              {{ transaction.Amount >= 0 ? '+' : '' }}{{ transaction.Amount | FortressCurrencyPipe: 'PTS' }}
            </div>
            <div *ngIf="transaction.AccountDescriptionId == 0" class="text-muted">
              {{ 'fgbcl.card.linking.transaction.status.pending.text' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(!transactions$ || !hasTransactions) && !loading">
  <div class="mt-4">
    <span class="icon material-icons d-flex mx-auto align-items-center justify-content-center">history</span>
    <h5 class="text-primary text-center mt-2 mb-0 fw-bold text-uppercase font-size-16">
      {{ 'fgbcl.card.linking.no.transaction.date.label' | translate }}
    </h5>
    <p class="text-info text-center font-size-12">
      {{ 'fgbcl.card.linking.no.transaction.date.description' | translate }}
    </p>
  </div>
</ng-container>

<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
